import { Injectable } from '@angular/core';
import { environment } from './environment';
import { IEnvironment } from './environment.type';
import { udeploy } from './udeploy';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService implements IEnvironment {
  get appTheme(): string {
    return udeploy.appTheme || environment.appTheme;
  }

  get bingSiteVerificationKey(): string {
    return (
      udeploy.bingSiteVerificationKey || environment.bingSiteVerificationKey
    );
  }

  get cardinalScriptUrl(): string {
    return udeploy.cardinalScriptUrl || environment.cardinalScriptUrl;
  }

  get defaultTheme(): string {
    return udeploy.defaultTheme || environment.defaultTheme;
  }

  get googleSiteVerificationKey(): string {
    return (
      udeploy.googleSiteVerificationKey || environment.googleSiteVerificationKey
    );
  }

  get production(): boolean {
    return environment.production || false;
  }

  get basic_version(): boolean {
    return environment.basic_version || false;
  }

  get tridionBaseUrl(): string {
    return udeploy.tridionBaseUrl || environment.tridionBaseUrl;
  }

  get tridionSite(): string {
    return udeploy.tridionSite || environment.tridionSite;
  }

  get accountAppPath(): string {
    return udeploy.accountAppPath || environment.accountAppPath;
  }

  get adobeAutosearchUrl(): string {
    return udeploy.adobeAutosearchUrl || environment.adobeAutosearchUrl;
  }

  get adobeHeaderScript(): string {
    return udeploy.adobeHeaderScript || environment.adobeHeaderScript;
  }

  get adobeBodyScript(): string {
    return udeploy.adobeBodyScript || environment.adobeBodyScript;
  }

  get adobeMbox(): string {
    return udeploy.adobeMbox || environment.adobeMbox;
  }

  get adobeTargetDisabled(): boolean {
    return udeploy.adobeTargetDisabled || environment.adobeTargetDisabled;
  }

  get defaultCountry(): string {
    return udeploy.defaultCountry || environment.defaultCountry || 'ja';
  }

  get defaultLanguage(): string {
    return udeploy.defaultLanguage || environment.defaultLanguage;
  }

  get denaliUrl(): string {
    return udeploy.denaliUrl || environment.denaliUrl;
  }

  get digitalDataAdblockerEnabled(): boolean {
    return (
      udeploy.digitalDataAdblockerEnabled ||
      environment.digitalDataAdblockerEnabled
    );
  }

  get digitalDataAppVersion(): string {
    return udeploy.digitalDataAppVersion || environment.digitalDataAppVersion;
  }

  get digitalDataAngularVersion(): string {
    return (
      udeploy.digitalDataAngularVersion || environment.digitalDataAngularVersion
    );
  }

  get digitalDataDestination(): string {
    return udeploy.digitalDataDestination || environment.digitalDataDestination;
  }

  get digitalDataEnabled(): boolean {
    return udeploy.digitalDataEnabled || environment.digitalDataEnabled;
  }

  get digitalDataSegment(): string {
    return udeploy.digitalDataSegment || environment.digitalDataSegment;
  }

  get digitalDataEnvironment(): string {
    return udeploy.digitalDataEnvironment || environment.digitalDataEnvironment;
  }

  get digitalDataFlashVersion(): string {
    return (
      udeploy.digitalDataFlashVersion || environment.digitalDataFlashVersion
    );
  }

  get digitalDataSite(): string {
    return udeploy.digitalDataSite || environment.digitalDataSite;
  }

  get digitalDataTridionVersion(): string {
    return (
      udeploy.digitalDataTridionVersion || environment.digitalDataTridionVersion
    );
  }

  get facebookLikeUrl(): string {
    return udeploy.facebookLikeUrl || environment.facebookLikeUrl;
  }

  get fontCssUrl(): string {
    return udeploy.fontCssUrl || environment.fontCssUrl;
  }

  get iconCssUrl(): string {
    return udeploy.iconCssUrl || environment.iconCssUrl;
  }

  get globalNavigationEnabled(): boolean {
    return (
      udeploy.globalNavigationEnabled || environment.globalNavigationEnabled
    );
  }

  get grecaptchaApiUrl(): string {
    return udeploy.grecaptchaApiUrl || environment.grecaptchaApiUrl;
  }

  get grecaptchaSiteKey(): string {
    return udeploy.grecaptchaSiteKey || environment.grecaptchaSiteKey;
  }

  get grecaptchaEnabled(): boolean {
    return udeploy.grecaptchaEnabled || environment.grecaptchaEnabled;
  }

  get grecaptchaTestResponse(): string {
    return udeploy.grecaptchaTestResponse || environment.grecaptchaTestResponse;
  }

  get layoutHeader(): string {
    return udeploy.layoutHeader || environment.layoutHeader;
  }

  get mobileServicesApi(): any {
    return udeploy.mobileServicesApi || environment.mobileServicesApi;
  }

  get mobileServicesApiBaseUrl(): any {
    return (
      udeploy?.mobileServicesApi?.baseUrl ||
      environment?.mobileServicesApi?.baseUrl
    );
  }
  get mobileServicesApiKey(): any {
    return (
      udeploy?.mobileServicesApi?.key || environment?.mobileServicesApi?.key
    );
  }
  get mobileServicesApiToken(): any {
    return (
      udeploy.mobileServicesApi?.token || environment.mobileServicesApi?.token
    );
  }
  get mobileServicesApiCity(): any {
    return (
      udeploy.mobileServicesApi?.city || environment.mobileServicesApi?.city
    );
  }

  get mobileServicesShowtimesEndpoint(): any {
    return (
      udeploy.mobileServicesApi?.showTimesEndpoint ||
      environment.mobileServicesApi?.showTimesEndpoint
    );
  }

  get mobileServicesVenueEndpoints(): any {
    return (
      udeploy.mobileServicesApi?.venueEndpoint ||
      environment.mobileServicesApi?.venueEndpoint
    );
  }

  get oauthBaseUrl(): string {
    return udeploy.oauthBaseUrl || environment.oauthBaseUrl;
  }

  get oauthClientKeyID(): string {
    return udeploy.oauthClientKeyID || environment.oauthClientKeyID;
  }

  get oauthAppFlowPath(): string {
    return udeploy.oauthAppFlowPath || environment.oauthAppFlowPath;
  }

  get oauthAppPasswordFlowPath(): string {
    return (
      udeploy.oauthAppPasswordFlowPath || environment.oauthAppPasswordFlowPath
    );
  }

  get oauthAppSourceId(): string {
    return udeploy.oauthAppSourceId || environment.oauthAppSourceId;
  }

  get oidc(): typeof udeploy.oidc {
    return udeploy.oidc || environment.oidc;
  }

  get oidcBaseUrl(): string {
    return (udeploy.oidc.base_url || environment.oidc.base_url) ?? '';
  }

  get oidcEnabled(): boolean {
    return (udeploy.oidc.enabled || environment.oidc.enabled) ?? false;
  }

  get oidcRedirectEnabled(): boolean {
    return (
      (udeploy.oidc.redirect_enabled || environment.oidc.redirect_enabled) ??
      false
    );
  }

  get oidcRedirectApi(): string {
    return (udeploy.oidc.redirect_url || environment.oidc.redirect_url) ?? '';
  }

  get oidcClientId(): string {
    return (udeploy.oidc.client_id || environment.oidc.client_id) ?? '';
  }

  get oidcClientKeyID(): string {
    return (udeploy.oidc.client_secret || environment.oidc.client_secret) ?? '';
  }

  get oidcNodeApiBaseUrl(): string {
    return (
      (udeploy.oidc.node_api_base_url || environment.oidc.node_api_base_url) ??
      ''
    );
  }

  get oidcAppFlowPath(): string {
    return (udeploy.oidc.app_flow_path || environment.oidc.app_flow_path) ?? '';
  }

  get oidcAppPasswordFlowPath(): string {
    return (
      (udeploy.oidc.password_flow_path ||
        environment.oidc.password_flow_path) ??
      ''
    );
  }

  get oidcSignoffApi(): string {
    return (udeploy.oidc.end_session || environment.oidc.end_session) ?? '';
  }

  get oneTrustDomainScript(): string {
    return udeploy.oneTrustDomainScript || environment.oneTrustDomainScript;
  }

  get oneTrustEnabled(): boolean {
    return udeploy.oneTrustEnabled || environment.oneTrustEnabled;
  }

  get oneTrustModalScript(): string {
    return udeploy.oneTrustModalScript || environment.oneTrustModalScript;
  }

  get oneTrustHash(): string {
    return udeploy.oneTrustHash || environment.oneTrustHash;
  }

  get oneTrustCrossorigin(): string {
    return udeploy.oneTrustCrossorigin || environment.oneTrustCrossorigin;
  }

  get oneTrustPrivacyScript(): string {
    return udeploy.oneTrustPrivacyScript || environment.oneTrustPrivacyScript;
  }

  get oneTrustPrivacyIds(): string {
    return udeploy.oneTrustPrivacyIds || environment.oneTrustPrivacyIds;
  }

  get oneTrustPrivacyGeo(): string {
    return udeploy.oneTrustPrivacyGeo || environment.oneTrustPrivacyGeo;
  }

  get oneTrustPrivacyLSPA(): string {
    return udeploy.oneTrustPrivacyLSPA || environment.oneTrustPrivacyLSPA;
  }
  get coveo(): any {
    return udeploy.coveo || environment.coveo;
  }
  get coveoEnabled(): boolean {
    return udeploy.coveo.enabled || environment.coveo.enabled;
  }
  get coveoScriptSearchUrl(): string {
    return udeploy.coveo.scriptSearchUrl || environment.coveo.scriptSearchUrl;
  }
  get coveoScriptSearchHash(): string {
    return udeploy.coveo.scriptSearchHash || environment.coveo.scriptSearchHash;
  }
  get coveoScriptTemplateUrl(): string {
    return (
      udeploy.coveo.scriptTemplateUrl || environment.coveo.scriptTemplateUrl
    );
  }
  get coveoScriptTemplateHash(): string {
    return (
      udeploy.coveo.scriptTemplateHash || environment.coveo.scriptTemplateHash
    );
  }
  get coveoScriptLocale(): string {
    return udeploy.coveo.scriptLocale || environment.coveo.scriptLocale;
  }
  get coveoScriptLocaleHash(): string {
    return udeploy.coveo.scriptLocaleHash || environment.coveo.scriptLocaleHash;
  }
  get coveoCss(): string {
    return udeploy.coveo.css || environment.coveo.css;
  }
  get coveoCssHash(): string {
    return udeploy.coveo.cssHash || environment.coveo.cssHash;
  }
  get coveoCrossOrigin(): string {
    return udeploy.coveo.crossOrigin || environment.coveo.crossOrigin;
  }
  get coveoOrganizationId(): string {
    return udeploy.coveo.organizationId || environment.coveo.organizationId;
  }
  get coveoAccessKeyID(): string {
    return udeploy.coveo.accessKeyID || environment.coveo.accessKeyID;
  }

  get geo(): any {
    return udeploy.geo || environment.geo;
  }
  get geoDisabled(): boolean {
    return udeploy.geo.disabled || environment.geo.disabled;
  }

  get geoApiUrl(): string {
    return udeploy.geo.apiUrl || environment.geo.apiUrl;
  }
  get GEOLOCATION_AKAMAI(): boolean {
    return udeploy.geo.location.akamai || environment.geo.location.akamai;
  }
  get PRIMARY_GEO_REGION(): string {
    return udeploy.geo.region.primary || environment.geo.region.primary;
  }

  get weatherApi(): string {
    return udeploy.weatherApi || environment.weatherApi;
  }

  get googleCalendarApiKey(): string {
    return udeploy.googleCalendarApiKey || environment.googleCalendarApiKey;
  }

  get resortName(): string {
    return udeploy.resortName || environment.resortName;
  }

  get resortAreaCode(): string {
    return udeploy.resortAreaCode || environment.resortAreaCode;
  }

  get hmacKey(): string {
    return udeploy.hmacKey || environment.hmacKey;
  }

  get seoTitle(): string {
    return udeploy.seoTitle || environment.seoTitle;
  }

  get seoDescription(): string {
    return udeploy.seoDescription || environment.seoDescription;
  }

  get seoImage(): string {
    return udeploy.seoImage || environment.seoImage;
  }

  get seoFacebookSiteName(): string {
    return udeploy.seoFacebookSiteName || environment.seoFacebookSiteName;
  }

  get seoTwitterSiteName(): string {
    return udeploy.seoTwitterSiteName || environment.seoTwitterSiteName;
  }

  get sorryPagePath(): string {
    return udeploy.sorryPagePath || environment.sorryPagePath;
  }

  get tripDetailLink(): string {
    return udeploy.tripDetailLink || environment.tripDetailLink;
  }

  get uprvUrl(): string {
    return udeploy.uprvUrl || environment.uprvUrl;
  }

  get upsellPackages(): string {
    return udeploy.upsellPackages || environment.upsellPackages;
  }

  get wcsStoreId(): string {
    return udeploy.wcsStoreId || environment.wcsStoreId;
  }

  get webAppPath(): string {
    return udeploy.webAppPath || environment.webAppPath;
  }

  get webstoreAppPath(): string {
    return udeploy.webstoreAppPath || environment.webstoreAppPath;
  }

  get webstoreJunction(): string {
    return udeploy.webstoreJunction || environment.webstoreJunction;
  }

  get diningReservationsAppPath(): string {
    return (
      udeploy.diningReservationsAppPath || environment.diningReservationsAppPath
    );
  }

  get timeZone(): string {
    return udeploy.timeZone || environment.timeZone;
  }

  get uniWebServiceApiKey(): string {
    return udeploy.uniWebServiceApiKey || environment.uniWebServiceApiKey;
  }

  get COMPLETE_AP(): string {
    return udeploy.COMPLETE_AP || environment.COMPLETE_AP;
  }

  get commerceClientId(): string {
    return udeploy.commerceClientId || environment.commerceClientId;
  }
  get commerceClientKeyID(): string {
    return udeploy.commerceClientKeyID || environment.commerceClientKeyID;
  }
  get commerceApiUrl(): string {
    return udeploy.commerceApiUrl || environment.commerceApiUrl;
  }
  get wtsHostBaseUrl(): string {
    return udeploy.wtsHostBaseUrl || environment.wtsHostBaseUrl;
  }

  get entitlementBaseUrl(): string {
    return udeploy.entitlementBaseUrl || environment.entitlementBaseUrl;
  }

  get shareQrCodeUrl(): string {
    return udeploy.shareQrCodeUrl || environment.shareQrCodeUrl;
  }
  get linkEntitlement(): string {
    return udeploy.linkEntitlement || environment.linkEntitlement;
  }
  get gtmId(): string {
    return udeploy.gtmId || environment.gtmId;
  }

  get cookieSubDomain(): string {
    return udeploy.cookieSubDomain || environment.cookieSubDomain;
  }

  get contentApiBaseUrl(): string {
    return udeploy.contentApiBaseUrl || environment.contentApiBaseUrl;
  }

  get contentLoginClientID(): string {
    return udeploy.contentLoginClientID || environment.contentLoginClientID;
  }

  get contentLoginClientKeyID(): string {
    return (
      udeploy.contentLoginClientKeyID || environment.contentLoginClientKeyID
    );
  }

  get showDiningReservationLink(): boolean {
    return environment.config?.dashboard?.showDiningReservationLink || false;
  }

  get showBuyTicketsLink(): boolean {
    return environment.config?.dashboard?.showBuyTicketsLink || false;
  }

  get showLinkTicketsLink(): boolean {
    return environment.config?.dashboard?.showLinkTicketsLink || false;
  }

  get deletingUSHAccount(): boolean {
    return environment.config?.deletingUSHAccount || false;
  }

  get contentIdTokenUrl(): string {
    return udeploy.contentIdTokenUrl || environment.commerceApiUrl;
  }

  get pageLabelsUrl(): string {
    return udeploy.pageLabelsUrl || environment.pageLabelsUrl;
  }

  get version_dropdown(): boolean {
    return environment.version_dropdown || false;
  }

  get entitlementDataUrl(): string {
    return udeploy.entitlementDataUrl || environment.entitlementDataUrl;
  }

  get commerceApi(): string {
    return udeploy.commerceApi || environment.commerceApi;
  }

  get qrCodeAPIParam(): string {
    return environment.qrCodeAPIParam;
  }

  get qrCodeDomainUrl(): string {
    return environment.qrCodeDomainUrl;
  }

  get qrCodeAPIUrl(): string {
    return environment.qrCodeAPIUrl;
  }

  get isMMDDYYYYFormat(): boolean {
    return udeploy.isMMDDYYYYFormat || environment.isMMDDYYYYFormat;
  }

  get showEntitlementsInfo(): boolean {
    return environment.config?.showEntitlementsInfo || false;
  }
  get hideScanIconDesktop(): boolean {
    return environment.hideScanIconDesktop || false;
  }
  get defaultCurrency(): string {
    return environment.defaultCurrency;
  }
  get showPhoneCard(): boolean {
    return environment.showPhoneCard || false;
  }
  get showCommPrefCard(): boolean {
    return environment.showCommPrefCard || false;
  }
  get showPaymentCard(): boolean {
    return environment.showPaymentCard || false;
  }
  get showPasswordCard(): boolean {
    return environment.showPasswordCard || false;
  }
  get showLogoutCard(): boolean {
    return environment.showLogoutCard || false;
  }
  get showProfileBirthday(): boolean {
    return environment.showProfileBirthday || false;
  }
  get showProfileGender(): boolean {
    return environment.showProfileGender || false;
  }
  get showProfileUpdates(): boolean {
    return environment.showProfileUpdates || false;
  }
  get showEdit(): boolean {
    return environment.showEdit || false;
  }
  get contentIds(): any {
    return udeploy.contentIds || environment.contentIds;
  }
  get language_dropdown(): boolean {
    return environment.language_dropdown || false;
  }
  get crewToolsApi(): string {
    return udeploy.crewToolsApi || environment.crewToolsApi;
  }
  get rToasterTagId(): string {
    return udeploy.rToasterTagId || environment.rToasterTagId;
  }
  get isRToasterTagEnabled(): boolean {
    return environment.isRToasterTagEnabled || false;
  }
  get showCreditCardDetails(): boolean {
    return environment.showCreditCardDetails || false;
  }
  get taxCodes(): any {
    return udeploy.taxCodes || environment.taxCodes;
  }
  get showTaxLabel(): any {
    return udeploy.showTaxLabel || environment.showTaxLabel;
  }
  get subTotalTaxIncluded(): any {
    return udeploy.subTotalTaxIncluded || environment.subTotalTaxIncluded;
  }
  get showdeliveryCost(): any {
    return udeploy.showdeliveryCost || environment.showdeliveryCost;
  }
  get inquiryToken(): string {
    return udeploy.inquiryToken || environment.inquiryToken;
  }
  get oidcInquiryClientId(): string {
    return udeploy.oidcInquiryClientId || environment.oidcInquiryClientId;
  }
  get oidcInquiryClientKeyID(): string {
    return udeploy.oidcInquiryClientKeyID || environment.oidcInquiryClientKeyID;
  }
  get prependImageBaseUrl(): boolean {
    return environment.prependImageBaseUrl || true;
  }
  get baseRedirectBypass(): boolean {
    return udeploy.baseRedirectBypass || environment.baseRedirectBypass;
  }
  get specialOffers(): any {
    return udeploy.specialOffers || environment.specialOffers;
  }
  get showGalaxyTickets(): any {
    return udeploy.showGalaxyTickets || environment.showGalaxyTickets;
  }
  get showAlphanumericLinkError(): any {
    return (
      udeploy.showAlphanumericLinkError || environment.showAlphanumericLinkError
    );
  }
  get showICELinkInCoupon(): any {
    return udeploy.showICELinkInCoupon || environment.showICELinkInCoupon;
  }
  get SourceIdKey(): any {
    return udeploy.SourceIdKey || environment.SourceIdKey;
  }
  get getTicketsLink(): string {
    return udeploy.getTicketsLink || environment.getTicketsLink;
  }
  get deleteRedirectURL(): string {
    return udeploy.deleteRedirectURL || environment.deleteRedirectURL;
  }
  get CHOICE_A_SECTION(): string {
    return udeploy.CHOICE_A_SECTION || environment.CHOICE_A_SECTION;
  }
  get CHOICE_B_SECTION(): string {
    return udeploy.CHOICE_B_SECTION || environment.CHOICE_B_SECTION;
  }
  get shareQrEntitlementsAvailable(): boolean {
    return environment.shareQrEntitlementsAvailable || false;
  }
  get showCreditCardExpDate(): any {
    return udeploy.showCreditCardExpDate || environment.showCreditCardExpDate;
  }

  get displayDateByTimezone(): any {
    return udeploy.displayDateByTimezone || environment.displayDateByTimezone;
  }
  get parkInfo(): any {
    return udeploy.parkInfo || environment.parkInfo;
  }
  get faviconUrl(): string {
    return udeploy.faviconUrl || environment.faviconUrl;
  }
  get showTimesEndpoint(): any {
    return (
      udeploy?.mobileServicesApi?.showTimesEndpoint ||
      environment?.mobileServicesApi?.showTimesEndpoint
    );
  }
  get venueEndpoint(): any {
    return (
      udeploy?.mobileServicesApi?.venueEndpoint ||
      environment?.mobileServicesApi?.venueEndpoint
    );
  }
  get contentOidcTokenApi(): any {
    return udeploy.contentOidcTokenApi || environment.contentOidcTokenApi;
  }
  get fetchTravelPartyUrl(): any {
    return udeploy.fetchTravelPartyUrl || environment.fetchTravelPartyUrl;
  }
  get deleteAccountConfirmationFlow(): boolean {
    return (
      udeploy.deleteAccountConfirmationFlow ||
      environment.deleteAccountConfirmationFlow
    );
  }
  get pageLabels(): any {
    return udeploy.pageLabels || environment.pageLabels;
  }
  get sendParamsTravelParty(): boolean {
    return udeploy.sendParamsTravelParty || environment.sendParamsTravelParty;
  }

  get checkSaveTimeProperty(): boolean {
    return udeploy.checkSaveTimeProperty || environment.checkSaveTimeProperty;
  }
}
